import { useTheme } from '@mui/material';
import EntityCard, { EntityCardStat } from '../dashboard/entityCard';

type Props = { dataSourceInstance: any; openDataSourceInstance: (dataSourceInstance: any) => void };

const DataSourceInstanceIcon = ({ dataSourceInstance, openDataSourceInstance }: Props) => {
  const theme = useTheme();

  const stats: EntityCardStat[] = [];

  if (dataSourceInstance?.usageStats) {
    const s = dataSourceInstance.usageStats;
    if (s.dataSourceItemStats?.total !== undefined) stats.push({ label: 'items', value: s.dataSourceItemStats.total });
    if (s.dataSourceItemStats?.processed !== undefined) stats.push({ label: 'done', value: s.dataSourceItemStats.processed });
    if (s.dataSourceItemStats?.failed !== undefined && s.dataSourceItemStats.failed > 0) stats.push({ label: 'failed', value: s.dataSourceItemStats.failed });
    if (s.subscribers !== undefined) stats.push({ label: 'subs', value: s.subscribers });
  }

  if (dataSourceInstance?.eventSubscriptions?.length > 0) {
    if (stats.length === 0) stats.push({ label: 'events', value: dataSourceInstance.eventSubscriptions.length });
  }

  return (
    <EntityCard
      name={dataSourceInstance.name}
      type={dataSourceInstance?.dataSourceDef?.name || 'Data Source'}
      icon={dataSourceInstance?.dataSourceDef?.instanceIcon || 'database'}
      color={theme.palette.secondary.main}
      onClick={() => openDataSourceInstance(dataSourceInstance)}
      statusLabel={dataSourceInstance.active !== false ? 'active' : 'inactive'}
      description={dataSourceInstance.description}
      stats={stats.length > 0 ? stats.slice(0, 4) : undefined}
      createdDate={dataSourceInstance.createdDate}
      lastUpdatedDate={dataSourceInstance.lastUpdatedDate}
    />
  );
};

export default DataSourceInstanceIcon;
